import { render, staticRenderFns } from "./fluxMonitor.vue?vue&type=template&id=07fb705a&"
import script from "./fluxMonitor.vue?vue&type=script&lang=js&"
export * from "./fluxMonitor.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports